<template>
  <div class="CadastroConfigRentab">
    <el-button 
      style="float: right; padding: 5px 5px"
      @click="dialogFormVisible = true"
      icon="el-icon-circle-plus"
      type="primary"
      plain
      round
    >Novo Valor</el-button>

    <!-- DIALOG DE CADASTRO DE RENTABILIDADE -->
    <el-dialog title="Novo Rentabilidade" :visible="dialogFormVisible" :show-close="false">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        :label-position="labelPosition"
        class="demo-ruleForm"
      >
        <el-form-item label="Rentabilidade" prop="valor">
          <el-input v-model.lazy="ruleForm.valor" v-money="money" >
            <template slot="append">%</template>
          </el-input>

        </el-form-item>
 
      </el-form>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleFechar()">Cancelar</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">Salvar</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import {VMoney} from 'v-money';

// const url = "http://" + window.location.hostname + ":8000/api";
//const url = "http://app-laravel:8000/api";
const url = '/api';

// import {VMoney} from 'v-money';

export default {
  //  directives: {money: VMoney},
  data() {
    return {
      price: 123.45,
        money: {
          decimal: ',',
          thousands: '.',
        //  prefix: 'R$ ',
         //suffix: ' #',
          precision: 2,
          masked: false /* doesn't work with directive */
        },

      labelPosition: "right",
      dialogFormVisible: false,
      ruleForm: {
        valor: "",
      },
 
      rules: {
        valor: [
          {
            required: true,
            message: "Informe o Percentual da Rentabilidade",
            trigger: "blur",
          },
        ],
      },
    };
  },
    directives: {money: VMoney},
  methods: {
    //CADASTRO DADOS
    handleFechar() {
      this.$confirm("Tem certeza que deseja sair?", "Aviso", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning",
      })
        .then(() => {
          this.dialogFormVisible = false;
          this.ruleForm.valor = "";
        })
        .catch(() => {
          this.dialogFormVisible = true;
        });
    },

    submitForm(formName) {

      this.$refs[formName].validate((valid) => {
        if (valid) {
                let vl;
               vl = this.ruleForm.valor;
               vl = vl.replace('.','');
               this.ruleForm.valor = vl.replace(',','.');
          let dados = {
            valor: this.ruleForm.valor,
          };
          axios
            .post(url + "/config_rentab/", dados, {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            })
            .then(() => {
              this.$notify({
                title: "Sucesso",
                message: "Registro Salvo com sucesso!",
                type: "success",
              });
              this.dialogFormVisible = false;
              this.ruleForm.valor = "";
              this.$emit("dadosRentab-click");
            })
            .catch((err) => {
              this.$notify({
                title: "Erro",
                message:
                  "Erro ao cadastrar os dados! Tente novamente mais tarde!" +
                  err,
                type: "error",
              });
              this.dialogFormVisible = false;
              this.ruleForm.valor = "";
            });
        } else {
          this.$message({
            type: "info",
            message: "Informe os dados corretamente!",
          });
          return false;
        }
      });
    },
    //FIM CADASTRO DADOS
  },
};
</script>